import React from 'react'

const RightArrowIcon: React.FC = (props) => (
	<svg {...props} width='45' height='49' viewBox='0 0 45 49' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M3 3L41.8291 24.8417L22.4146 35.2625L3 45.6833'
			stroke='currentColor'
			strokeWidth='5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
)

export default RightArrowIcon
